<!-- eslint-disable prettier/prettier -->
<template>
    <v-container fluid>
        <v-card>
            <v-toolbar dark color="secondary" class="white--text" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    Badges & Credentials
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container fluid>
                <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
                <v-form ref="form" lazy-validation>
                    <v-row class="">
                        <v-col cols="12" md="3">
                            <v-combobox label="Select Driver" :items="drivers" chips dense :item-text="'Name'"
                                :item-value="'id'" auto-select-first v-model="driver"
                                @change="chargeData()"></v-combobox>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-text-field label="Driver ID" dense v-model="driver.id" outlined readonly>
                                <template v-slot:append>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-show="driver" v-on="on"
                                                color="primary">mdi-information-outline</v-icon>
                                        </template>
                                        <span>Driver Name:
                                            <b>{{ driver.Name }}</b></span><br />
                                        <span>Driver ID:
                                            <b>{{ driver.id }}</b></span><br />
                                        <br />
                                        <span>Driver Status:
                                            <b>{{
                                                driver.Active
                                                    ? 'Active'
                                                    : 'Inactive'
                                            }}</b></span><br />
                                        <span>Driver Address:
                                            <b>{{ driver.Address }}</b></span><br />
                                        <span>Driver City:
                                            <b>{{ driver.City }}</b></span><br />
                                        <span>Driver Province:
                                            <b>{{ driver.Province }}</b></span><br />
                                        <span>Driver Postal Code:
                                            <b>{{ driver.PostalCode }}</b></span><br />
                                        <span>Driver Birth Date:
                                            <b>{{ driver.BirthDate }}</b></span><br />
                                        <br />
                                        <span>Driver Email:
                                            <b>{{ driver.Email }}</b></span><br />
                                        <span>Driver Phone 1:
                                            <b>{{ driver.Telephone }}</b></span><br />
                                        <span>Driver Phone 2:
                                            <b>{{ driver.Telephone2 }}</b></span><br />
                                        <span>Driver SIN:
                                            <b>{{ driver.SIN }}</b></span><br />
                                    </v-tooltip>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="2">
                            <v-btn v-show="nav <= 2" class="mb-2" color="secondary" @click="nav == 1 ? load_dialog_badge = true : unload_dialog_badge = true">
                                <v-icon>mdi-plus-circle-outline</v-icon>
                                Badge
                            </v-btn>
                            <v-btn v-show="nav <= 2" class="mb-2 ml-2" color="secondary"
                                @click="cleanBadgesCredential(1)">
                                <v-icon>mdi-broom</v-icon>
                                Clean
                            </v-btn>

                            <v-btn v-show="nav == 3" class="mb-2" color="secondary" @click="
                                $store.state.credential.dialog = true
                                ">
                                <v-icon>mdi-plus-circle-outline</v-icon>
                                Credentials
                            </v-btn>
                        </v-col>
                        <v-spacer />
                        <v-col cols="12" md="3" xl="2">
                            <v-menu offset-y bottom>
                                <template v-slot:activator="{ on: menu, attrs }">
                                    <v-btn block v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                                        <v-icon>mdi-file-document-edit-outline</v-icon>
                                        Badge Reports
                                    </v-btn>
                                </template>
                                <v-list dense color="blue-grey lighten-5">
                                    <v-list-item @click="createReport(7, 'badge')">7 Days report</v-list-item>
                                    <v-list-item @click="createReport(15, 'badge')">15 Days report</v-list-item>
                                    <v-list-item @click="createReport(30, 'badge')">30 Days report</v-list-item>
                                    <v-list-item @click="createReport(90, 'badge')">90 Days report</v-list-item>
                                    <v-list-item @click="createReport(120, 'badge')">120 Days report</v-list-item>
                                    <v-list-item @click="createReport(180, 'badge')">180 Days report</v-list-item>
                                    <v-list-item @click="createReport(-1, 'badge')">General report</v-list-item>
                                </v-list>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="3" xl="2">
                            <v-menu offset-y bottom>
                                <template v-slot:activator="{ on: menu, attrs }">
                                    <v-btn block v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                                        <v-icon>mdi-file-document-edit-outline</v-icon>
                                        Credential Reports
                                    </v-btn>
                                </template>
                                <v-list dense color="blue-grey lighten-5">
                                    <v-list-item @click="createReport(7, 'credential')">7 Days report</v-list-item>
                                    <v-list-item @click="createReport(15, 'credential')">15 Days report</v-list-item>
                                    <v-list-item @click="createReport(30, 'credential')">30 Days report</v-list-item>
                                    <v-list-item @click="createReport(90, 'credential')">90 Days report</v-list-item>
                                    <v-list-item @click="createReport(120, 'credential')">120 Days report</v-list-item>
                                    <v-list-item @click="createReport(180, 'credential')">180 Days report</v-list-item>
                                </v-list>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row v-show="driver">
                        <v-col cols="12">
                            <v-card>
                                <v-tabs height="47" color="teal" grow>
                                    <v-tab slider-color="secondary" @click="nav = 1">
                                        <v-icon>mdi-shield-star</v-icon>
                                        Badges to Load
                                    </v-tab>
                                    <v-tab slider-color="secondary" @click="nav = 2">
                                        <v-icon>mdi-shield-star</v-icon>
                                        Badges to UnLoad
                                    </v-tab>
                                    <v-tab slider-color="secondary" @click="nav = 3">
                                        <v-icon>mdi-badge-account-horizontal-outline</v-icon>
                                        Credentials
                                    </v-tab>
                                </v-tabs>

                                <v-col cols="12" v-if="nav == 1">
                                    <v-data-table :headers="badgeHeaders" :items="badgesLoad" dense 
                                        fixed-header
                                        height="650px"
                                        hide-default-footer disable-pagination class="white">
                                        <template v-slot:item.TerminalName="{ item }">
                                            <v-icon :color="item.Color">
                                                mdi-circle
                                            </v-icon>
                                            {{ item.TerminalName }}
                                        </template>

                                        <template v-slot:item.BadgeNumber="{ item }">
                                            <v-text-field dense v-model="item.BadgeNumber" type="number"
                                                hide-details></v-text-field>
                                        </template>

                                        <template v-slot:item.IsPermittedToUnload="{
                                            item
                                        }">
                                            <v-checkbox v-model="item.IsPermittedToUnload
                                                " class="ma-0" dense hide-details />
                                        </template>
                                        <template v-slot:item.IsPermittedToLoad="{
                                            item
                                        }">
                                            <v-checkbox v-model="item.IsPermittedToLoad
                                                " class="ma-0" dense hide-details />
                                        </template>
                                        <template v-slot:item.last_order="{ item }">
                                            {{
                                                item.last_order === null  ? 'N/A' :item.last_order.OrderID  
                                            }}
                                            <!--Create a tooltip inside an info icon to display additional data-->
                                            <v-tooltip v-if="item.last_order" bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-icon v-on="on" color="primary">mdi-information-outline</v-icon>
                                                </template>
                                                <div>
                                                    <span>ShiftDetail:
                                                        <b>{{
                                                            item.last_order
                                                                .ShiftDetail
                                                        }}</b></span><br />
                                                    <span>Order Number:
                                                        <b>{{
                                                            item.last_order
                                                                .OrderID
                                                        }}</b></span><br />
                                                    <span>Order Delivery Date:
                                                        <b>{{
                                                            item.last_order
                                                                .DateDelivered
                                                        }}</b></span><br />
                                                    <span>Order Status:
                                                        <b>{{
                                                            item.last_order
                                                                .OrderStatus
                                                        }}</b></span><br />
                                                    <span>Order Load Status:
                                                        <b>{{
                                                            item.last_order
                                                                .OrdLoadStatus
                                                        }}</b></span><br />
                                                    <v-spacer></v-spacer>
                                                    <span>Orders in the last
                                                        Year:
                                                        <b>{{
                                                            item.OrderCountInLastYear
                                                        }}</b></span><br />
                                                    <span>Orders in the last 180
                                                        Days:
                                                        <b>{{
                                                            item.OrderCountInLast180Days
                                                        }}</b></span>
                                                </div>
                                            </v-tooltip>
                                        </template>

                                        <template v-slot:item.InactiveBadgeExpirationCountdown="{
                                            item
                                        }">
                                            <v-icon>mdi-timer-sand</v-icon>
                                            <span :class="getExpirationColor(
                                                item.InactiveBadgeExpirationCountdown
                                            )
                                                ">{{
                                                    item.InactiveBadgeExpirationCountdown === null
                                                        ? 'N/A' : item.InactiveBadgeExpirationCountdown + ' Days left '
                                                }}</span>
                                            <!--Create a tooltip inside an info icon to display additional data-->
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-icon v-show="item.InactiveBadgeExpirationCountdown
                                                        " v-on="on" color="primary">mdi-information-outline</v-icon>
                                                </template>
                                                <span>Badge expires at:
                                                    {{
                                                        item.InactiveBadgeExpirationDate
                                                    }}</span><br />
                                                <span>Terminal expiration period:
                                                    {{
                                                        item.InactiveBadgeExpirationPeriod
                                                    }}
                                                    Days.</span>
                                            </v-tooltip>
                                            <!--<v-text-field dense v-model="item.InactiveBadgeExpirationPeriod" hide-details readonly>
                      </v-text-field>-->
                                        </template>

                                        <template v-slot:item.ExpirationDate="{ item }">
                                            <div class="ma-2">
                                                <v-text-field class="pt-2 pb-1" compact label="Expiration Date" v-model="item.ExpirationDate
                                                    " :rules="$store.state.dateRules
                                                        " v-mask="$store.state.mask" hide-details readonly>
                                                    <template v-slot:prepend>
                                                        <v-icon>mdi-clock-fast</v-icon>
                                                    </template>
                                                </v-text-field>
                                            </div>
                                        </template>
                                        <template v-slot:item.LastActiveDate="{ item }">
                                            <v-text-field class="pt-2 pb-1" dense label="Inactive Expiration Date"
                                                v-model="item.LastActiveDate
                                                    " :rules="$store.state.dateRules
                                                            " v-mask="$store.state.mask" hide-details readonly>
                                                <template v-slot:prepend>
                                                    <v-icon>mdi-clock-alert-outline</v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <template v-slot:item.OrientationExpDate="{ item }">
                                            <v-text-field class="pt-2" dense label="Orientation Expiration Date"
                                                v-model="item.OrientationExpDate
                                                    " :rules="$store.state.dateRules
                                                            " v-mask="$store.state.mask" hide-details>
                                                <template v-slot:prepend>
                                                    <v-icon>mdi-clock-end</v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <template v-slot:item.IsActive="{ item }">
                                            <v-checkbox v-model="item.IsActive" class="ma-0" :color="item.IsActive == 1 &&
                                                item.LockedOut == 0
                                                ? 'green'
                                                : 'red'
                                                " hide-details :disabled="item.LockedOut == 1">
                                                <template v-slot:label>
                                                    <span v-if="
                                                        item.IsActive ==
                                                        1 &&
                                                        item.LockedOut ==
                                                        0
                                                    " class="green--text">Active</span>
                                                    <span v-else-if="
                                                        item.IsActive ==
                                                        1 &&
                                                        item.LockedOut ==
                                                        1
                                                    " class="gray--text">Locked</span>
                                                    <span v-else class="red--text">Inactive</span>
                                                </template>
                                            </v-checkbox>
                                            <v-checkbox v-model="item.LockedOut" v-show="item.IsActive == 1 ||
                                                item.LockedOut == 1
                                                " class="ma-0" hide-details :label="item.LockedOut
                                                    ? 'Locked'
                                                    : 'Unlocked'
                                                    "></v-checkbox>
                                        </template>

                                        <template v-slot:item.Comments="{ item }">
                                            <v-textarea dense rows="2" v-model="item.Comments"
                                                hide-details></v-textarea>
                                        </template>

                                        <template v-slot:item.actions="{ item }">
                                            <v-btn color="secondary" dark @click="editBadge(item)" icon>
                                                <v-icon>mdi-content-save</v-icon>
                                            </v-btn>
                                            <v-menu left offset-x>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn v-on="on" color="error" icon>
                                                        <v-icon>mdi-delete</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-list dense>
                                                    <v-list-item dense @click="
                                                        deleteBadge(item)
                                                        ">Confirm
                                                        deletion</v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </template>
                                    </v-data-table>
                                </v-col>

                                <v-col cols="12" v-if="nav == 2">
                                    <v-data-table :headers="badgeHeaders" :items="badgesUnLoad" dense 
                                        fixed-header
                                        height="650px"
                                        hide-default-footer disable-pagination class="white">
                                        <template v-slot:item.TerminalName="{ item }">
                                            <v-icon :color="item.Color">
                                                mdi-circle
                                            </v-icon>
                                            {{ item.TerminalName }}
                                        </template>

                                        <template v-slot:item.BadgeNumber="{ item }">
                                            <v-text-field dense v-model="item.BadgeNumber" type="number"
                                                hide-details></v-text-field>
                                        </template>

                                        <template v-slot:item.IsPermittedToUnload="{
                                            item
                                        }">
                                            <v-checkbox v-model="item.IsPermittedToUnload
                                                " class="ma-0" dense hide-details />
                                        </template>
                                        <template v-slot:item.IsPermittedToLoad="{
                                            item
                                        }">
                                            <v-checkbox v-model="item.IsPermittedToLoad
                                                " class="ma-0" dense hide-details />
                                        </template>
                                        <template v-slot:item.last_order="{ item }">
                                            {{
                                                item.last_order === null  ? 'N/A' :item.last_order.OrderID  
                                            }}
                                            <!--Create a tooltip inside an info icon to display additional data-->
                                            <v-tooltip v-if="item.last_order" bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-icon v-on="on" color="primary">mdi-information-outline</v-icon>
                                                </template>
                                                <div>
                                                    <span>ShiftDetail:
                                                        <b>{{
                                                            item.last_order
                                                                .ShiftDetail
                                                        }}</b></span><br />
                                                    <span>Order Number:
                                                        <b>{{
                                                            item.last_order
                                                                .OrderID
                                                        }}</b></span><br />
                                                    <span>Order Delivery Date:
                                                        <b>{{
                                                            item.last_order
                                                                .DateDelivered
                                                        }}</b></span><br />
                                                    <span>Order Status:
                                                        <b>{{
                                                            item.last_order
                                                                .OrderStatus
                                                        }}</b></span><br />
                                                    <span>Order Load Status:
                                                        <b>{{
                                                            item.last_order
                                                                .OrdLoadStatus
                                                        }}</b></span><br />
                                                    <v-spacer></v-spacer>
                                                    <span>Orders in the last
                                                        Year:
                                                        <b>{{
                                                            item.OrderCountInLastYear
                                                        }}</b></span><br />
                                                    <span>Orders in the last 180
                                                        Days:
                                                        <b>{{
                                                            item.OrderCountInLast180Days
                                                        }}</b></span>
                                                </div>
                                            </v-tooltip>
                                        </template>

                                        <template v-slot:item.InactiveBadgeExpirationCountdown="{
                                            item
                                        }">
                                            <v-icon>mdi-timer-sand</v-icon>
                                            <span :class="getExpirationColor(
                                                item.InactiveBadgeExpirationCountdown
                                            )
                                                ">{{
                                                    item.InactiveBadgeExpirationCountdown === null
                                                        ? 'N/A' : item.InactiveBadgeExpirationCountdown + ' Days left '
                                                }}</span>
                                            <!--Create a tooltip inside an info icon to display additional data-->
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-icon v-show="item.InactiveBadgeExpirationCountdown
                                                        " v-on="on" color="primary">mdi-information-outline</v-icon>
                                                </template>
                                                <span>Badge expires at:
                                                    {{
                                                        item.InactiveBadgeExpirationDate
                                                    }}</span><br />
                                                <span>Terminal expiration period:
                                                    {{
                                                        item.InactiveBadgeExpirationPeriod
                                                    }}
                                                    Days.</span>
                                            </v-tooltip>
                                            <!--<v-text-field dense v-model="item.InactiveBadgeExpirationPeriod" hide-details readonly>
                      </v-text-field>-->
                                        </template>

                                        <template v-slot:item.ExpirationDate="{ item }">
                                            <div class="ma-2">
                                                <v-text-field class="pt-2 pb-1" compact label="Expiration Date" v-model="item.ExpirationDate
                                                    " :rules="$store.state.dateRules
                                                        " v-mask="$store.state.mask" hide-details readonly>
                                                    <template v-slot:prepend>
                                                        <v-icon>mdi-clock-fast</v-icon>
                                                    </template>
                                                </v-text-field>
                                            </div>
                                        </template>
                                        <template v-slot:item.InactiveBadgeExpirationDate="{ item }">
                                            <v-text-field class="pt-2 pb-1" dense label="Inactive Expiration Date"
                                                v-model="item.InactiveBadgeExpirationDate
                                                    " :rules="$store.state.dateRules
                                                            " v-mask="$store.state.mask" hide-details readonly>
                                                <template v-slot:prepend>
                                                    <v-icon>mdi-clock-alert-outline</v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <template v-slot:item.OrientationExpDate="{ item }">
                                            <v-text-field class="pt-2" dense label="Orientation Expiration Date"
                                                v-model="item.OrientationExpDate
                                                    " :rules="$store.state.dateRules
                                                            " v-mask="$store.state.mask" hide-details>
                                                <template v-slot:prepend>
                                                    <v-icon>mdi-clock-end</v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <template v-slot:item.IsActive="{ item }">
                                            <v-checkbox v-model="item.IsActive" class="ma-0" :color="item.IsActive == 1 &&
                                                item.LockedOut == 0
                                                ? 'green'
                                                : 'red'
                                                " hide-details :disabled="item.LockedOut == 1">
                                                <template v-slot:label>
                                                    <span v-if="
                                                        item.IsActive ==
                                                        1 &&
                                                        item.LockedOut ==
                                                        0
                                                    " class="green--text">Active</span>
                                                    <span v-else-if="
                                                        item.IsActive ==
                                                        1 &&
                                                        item.LockedOut ==
                                                        1
                                                    " class="gray--text">Locked</span>
                                                    <span v-else class="red--text">Inactive</span>
                                                </template>
                                            </v-checkbox>
                                            <v-checkbox v-model="item.LockedOut" v-show="item.IsActive == 1 ||
                                                item.LockedOut == 1
                                                " class="ma-0" hide-details :label="item.LockedOut
                                                    ? 'Locked'
                                                    : 'Unlocked'
                                                    "></v-checkbox>
                                        </template>

                                        <template v-slot:item.Comments="{ item }">
                                            <v-textarea dense rows="2" v-model="item.Comments"
                                                hide-details></v-textarea>
                                        </template>

                                        <template v-slot:item.actions="{ item }">
                                            <v-btn color="secondary" dark @click="editBadge(item)" icon>
                                                <v-icon>mdi-content-save</v-icon>
                                            </v-btn>
                                            <v-menu left offset-x>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn v-on="on" color="error" icon>
                                                        <v-icon>mdi-delete</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-list dense>
                                                    <v-list-item dense @click="
                                                        deleteBadge(item)
                                                        ">Confirm
                                                        deletion</v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </template>
                                    </v-data-table>
                                </v-col>

                                <v-col cols="12" v-else-if="nav == 3">
                                    <v-data-table :headers="credentialHeaders" :items="credential" dense 
                                        fixed-header
                                        height="650px"
                                        hide-default-footer>
                                        <template v-slot:item.credential_type.CredType="{
                                            item
                                        }">
                                            <v-combobox v-model="item.credential_type
                                                .CredType
                                                " :items="credentials" :item-text="'CredType'"
                                                :item-value="'CredTypeID'" auto-select-first></v-combobox>
                                        </template>
                                        <template v-slot:item.CredNumber="{ item }">
                                            <v-text-field dense v-model="item.CredNumber" hide-details></v-text-field>
                                        </template>
                                        <template v-slot:item.CredExpiry="{ item }">
                                            <v-text-field dense v-model="item.CredExpiry" hide-details></v-text-field>
                                        </template>

                                        <template v-slot:item.actions="{ item }">
                                            <v-btn color="secondary" dark @click="editCredential(item)" icon>
                                                <v-icon>mdi-content-save</v-icon>
                                            </v-btn>
                                            <v-menu left offset-x>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn v-on="on" color="error" icon>
                                                        <v-icon>mdi-delete</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-list dense>
                                                    <v-list-item dense @click="
                                                        deleteCredential(
                                                            item
                                                        )
                                                        ">Confirm
                                                        deletion</v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-card>
                        </v-col>
                    </v-row>
                    <!--Show a Skeleton loader if "driver" is null | hcobian -->
                    <template v-if="!driver">
                        <v-alert type="info" dismissible>
                            Please select a driver to display their badges and
                            credentials.
                        </v-alert>
                        <v-skeleton-loader v-if="!driver" type="table" :loading="true"
                            height="50vh"></v-skeleton-loader>
                    </template>
                </v-form>
            </v-container>
            <BadgeForm v-if="$store.state.badge.dialog" :drvID="driver.id" :terms="terminals" />
            <AddCredentialForm v-if="$store.state.credential.dialog" :drvID="driver.id" />
        </v-card>
        <v-dialog v-model="$store.state.report.dialog" scrollable light>
            <!--Create a report view of the badges that are about to expire from "report"-->
            <v-card>
                <v-card-title>
                    <span class="headline">Driver Carding Report (Total: {{ count }})</span>
                    <v-spacer></v-spacer>
                    <v-btn @click="downloadReport(report, reportHeaders, type)" color="secondary" dark>
                        <v-icon>mdi-file-download-outline</v-icon>
                        Download {{ type }} Report
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-data-table :headers="reportHeaders" :items="report" sort-by="InactiveBadgeExpirationCountdown"
                        show-group-by :items-per-page="1000" 
                    fixed-header
                    height="650px" hide-default-footer>
                        <template v-slot:item.driver.Name="{ item }">
                            <span :class="item.driver.Active
                                ? 'green--text'
                                : 'red--text'
                                ">{{ item.driver.Name }}</span>
                        </template>
                        <template v-slot:item.Color="{ item }">
                            <v-icon :color="item.Color">
                                mdi-circle
                            </v-icon>
                            <span :class="item.terminal.Active
                                ? 'green--text'
                                : 'red--text'
                                ">{{ item.terminal.TerminalName }}</span>
                        </template>
                        <template v-slot:item.IsPermittedToUnload="{ item }">
                            {{ item.IsPermittedToUnload ? 'Unload' : 'Load' }}
                        </template>
                        <template v-slot:item.LastOrder="{ item }">
                            {{
                                item.LastOrder
                                    ? item.LastOrder.DateTerminalPick
                                    : 'N/A'
                            }}
                        </template>
                        <template v-slot:item.InactiveBadgeExpirationCountdown="{
                            item
                        }">
                            <v-chip class="white--text" :color="getExpirationColor(
                                item.InactiveBadgeExpirationCountdown,
                                'color'
                            )
                                " label>
                                {{ item.InactiveBadgeExpirationCountdown }}
                            </v-chip>
                        </template>
                        <template v-slot:item.InactiveBadgeExpirationDate="{ item }">
                            {{
                                getExpirationDate(
                                    item.InactiveBadgeExpirationCountdown
                                )
                            }}
                        </template>
                        <template v-slot:item.IsActive="{ item }">
                            <v-chip class="white--text" :color="item.IsActive == 1 && item.LockedOut == 0
                                ? 'green'
                                : 'red'
                                " label>
                                {{
                                    item.IsActive == 1 && item.LockedOut == 0
                                        ? 'Active'
                                        : 'Inactive'
                                }}
                            </v-chip>
                        </template>
                        <template v-slot:item.CredExpiry="{ item }">
                            <span>{{ getDaysUntilDate(item.CredExpiry) }}
                            </span>
                            <span> | {{ item.CredExpiry }} </span>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>
        <load_terminal_badge v-if="load_dialog_badge" :load_dialog_badge="load_dialog_badge" :driver="driver.id"
            @close="load_dialog_badge = false;" @closeRecall="closeRecall"></load_terminal_badge>
        <unload_terminal_badge v-if="unload_dialog_badge" :unload_dialog_badge="unload_dialog_badge" :driver="driver.id"
        @close="unload_dialog_badge = false;" @closeRecall="closeRecall"></unload_terminal_badge>
        
            <alert_expire v-if="dialog_alert" :dialog_alert="dialog_alert" :alerts="alerts" @close="dialog_alert = false;"></alert_expire>

    </v-container>
</template>

<script>
import axios from 'axios';
import BadgeForm from './../Modals/Administration/Credentials/AddBadge.vue';
import AddCredentialForm from './../Modals/Administration/Credentials/AddCredential.vue';
import load_terminal_badge from './../Modals/Carding/LoadBadges.vue';
import unload_terminal_badge from './../Modals/Carding/UnloadBadges.vue';
import alert_expire from './../Modals/Carding/Alerts.vue';
import ConfirmDialogue from './../Modals/ConfirmDialogue.vue';
import { mask } from 'vue-the-mask';
export default {
    directives: { mask },
    components: {
        BadgeForm,
        AddCredentialForm,
        load_terminal_badge,
        unload_terminal_badge,
        ConfirmDialogue,
        alert_expire
    },
    data: function () {
        return {
            
            cpmt: 'Driver Credential',
            load_dialog_badge: false,
            unload_dialog_badge: false,
            dialog_alert: false,
            tooltip: {
                left: true,
                top: true
            },
            type: '',
            terminals: [],
            report: [],
            alerts:[],
            dateRules: [
                v => !!v || 'This date is required',
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect'
            ],
            credentialHeaders: [
                {
                    text: 'Credential',
                    value: 'credential_type.CredType'
                },
                {
                    text: 'Credential number',
                    value: 'CredNumber'
                },
                {
                    text: 'Expiration date',
                    value: 'CredExpiry'
                },
                { text: 'Actions', value: 'actions', sortable: false }
            ],
            badgeHeaders: [
                { text: 'Terminal', value: 'TerminalName' },
                { text: 'Badge Number', value: 'BadgeNumber' },
                // { text: 'UnLoad', value: 'IsPermittedToUnload' },
                // { text: 'Load', value: 'IsPermittedToLoad' },
                {
                    text: 'Last Load/Unload',
                    value: 'last_order',
                    sortable: false
                },
                {
                    text: 'Inactivity Expiration Countdown (IEC)',
                    value: 'InactiveBadgeExpirationCountdown'
                },
                {
                    text: 'Last Active Date',
                    value: 'LastActiveDate'
                },
                {
                    text: 'Expiration Date',
                    value: 'ExpirationDate'
                },

                {
                    text: 'Orientation Exp Date',
                    value: 'OrientationExpDate'
                },
                { text: 'Status', value: 'IsActive' },
                //{ text: 'Lockout', value: 'LockedOut'},
                { text: 'Comments', value: 'Comments' },
                { text: 'Actions', value: 'actions', sortable: false }
            ],
            badgeReportHeaders: [
                { text: 'Driver', value: 'driver.Name' },
                { text: 'Terminal', value: 'terminal.TerminalName' },
                { text: 'Badge ID', value: 'BadgeNumber' },
                { text: 'Type', value: 'IsPermittedToUnload' },
                { text: 'Last Load/Unload', value: 'LastActiveDate' },
                {
                    text: 'Inactivity Expiration Countdown (IEC)',
                    value: 'InactiveBadgeExpirationCountdown'
                },

                {
                    text: 'Last Active Date',
                    value: 'LastActiveDate'
                },
                {
                    text: 'Expiration Date',
                    value: 'ExpirationDate'
                },

                {
                    text: 'Orientation Exp Date',
                    value: 'OrientationExpDate'
                },

                { text: 'Expiration Date', value: 'ExpirationDate' },
                { text: 'Status', value: 'IsActive' },
                { text: 'Lockout', value: 'LockedOut' },
                { text: 'Comments', value: 'Comments' }
            ],
            credentialReportHeaders: [
                { text: 'Driver', value: 'driver.Name' },
                { text: 'Credential', value: 'credential_type.CredType' },
                { text: 'Credential number', value: 'CredNumber' },
                { text: 'Creation date', value: 'CreationDate' },
                { text: 'Expiration date', value: 'CredExpiry' }
            ],
            reportHeaders: [],
            drivers: [],
            badgesLoad: [],
            badgesUnLoad: [],
            count: 0,
            credential: [],
            credentials: [],
            driver: '',
            nav: 1
        };
    },
    mounted() {
        this.checkExpireBadge();
            this.timer = setInterval(() => {
                if(cpmt == 'Driver Credential'){
                    this.checkExpireBadge();
                }
            }, 1000 * 900);
        this.loadDrivers();
    },
    watch: {
        '$store.state.BadgeCred.watch': function () {
            if (this.$store.state.BadgeCred.watch == true) {
                this.chargeData();
                this.$store.state.BadgeCred.watch = false;
            }
        }
    },
    methods: {
        CleanBadge: function (nav) {
            axios
                .post('driver-badge/clear', { Driver: this.driver.id, BadgeType: nav }, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response);
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Clean Badges successfully'
                    });
                    this.chargeData();
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        this.$store.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        this.$store.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        closeRecall: function () {
            this.load_dialog_badge = false;
            this.unload_dialog_badge = false;
            this.chargeData();
        },
        convertToCSV(arr, headers) {
            // Extract headers:
            const csvHeaders = headers.map(header => header.text).join(',');

            // Map the rows:
            const rows = arr.map(obj =>
                headers
                    .map(header => {
                        const keys = header.value.split('.');
                        let value = obj;
                        keys.forEach(key => {
                            value = value[key] || '';
                        });
                        return `"${value.toString().replace(/"/g, '""')}"`;
                    })
                    .join(',')
            );

            // Combine headers and rows:
            return [csvHeaders, ...rows].join('\n');
        },
        downloadCSV(arr, headers, filename = 'data.csv') {
            const csvData = this.convertToCSV(arr, headers);
            const blob = new Blob([csvData], {
                type: 'text/csv;charset=utf-8;'
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            link.style.visibility = 'hidden';

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        downloadReport(items, headers, type = 'badge') {
            this.downloadCSV(items, headers, 'report_' + type + '.csv');
        },
        downloadDriverBadgeReport: function (
            badgeData,
            filename = 'grouped_driver_badge_report.csv'
        ) {
            // Helper function to group data by driver and format for CSV
            const groupAndFormatDataForCSV = data => {
                const groupedData = data.reduce((acc, item) => {
                    // Initialize the group array if it doesn't exist
                    if (!acc[item.Driver]) {
                        acc[item.Driver] = [];
                    }
                    // Add terminal info to the group
                    acc[item.Driver].push({
                        Terminal: item.Terminal,
                        BadgeID: item['Badge ID'],
                        ExpirationDate: item['Expiration Date']
                    });
                    return acc;
                }, {});

                // Convert grouped data to a flat array for CSV conversion
                const flattenedData = [];
                Object.keys(groupedData).forEach(driver => {
                    // Add the driver name as a separate entry
                    flattenedData.push({
                        Driver: driver,
                        Terminal: '',
                        BadgeID: '',
                        ExpirationDate: ''
                    });
                    groupedData[driver].forEach(badge => {
                        flattenedData.push({
                            Driver: '', // Keep the driver cell empty for badge entries
                            Terminal: badge.Terminal,
                            BadgeID: badge.BadgeID,
                            ExpirationDate: badge.ExpirationDate
                        });
                    });
                });
                return flattenedData;
            };

            // Define headers for the CSV
            const headers = [
                { text: 'Driver', value: 'Driver' },
                { text: 'Terminal', value: 'Terminal' },
                { text: 'Badge ID', value: 'BadgeID' },
                { text: 'Expiration Date', value: 'ExpirationDate' }
            ];

            // Process and group the badge data
            const groupedAndFormattedData = groupAndFormatDataForCSV(badgeData);

            // Use the provided downloadCSV method to download the report
            this.downloadCSV(groupedAndFormattedData, headers, filename);
        },
        loadDrivers: function () {
            axios
                .get('driver/active')
                .then(response => {
                    this.drivers = response.data.data;
                    console.table(this.drivers);
                    this.$store.dispatch('setSnackbar', {
                        color: 'secondary',
                        text: 'Select a Driver'
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        editBadge: function (itm) {
            var parms = {
                TerminalID: itm.TerminalID,
                BadgeNumber: itm.BadgeNumber,
                OrientationExpDate: itm.OrientationExpDate,
                IsPermittedToUnload: itm.IsPermittedToUnload,
                IsPermittedToLoad: itm.IsPermittedToLoad,
                IsActive: itm.IsActive,
                LockedOut: itm.LockedOut,
                Comments: itm.Comments
            };
            console.log(parms);
            axios
                .put('driver-badge/' + itm.DriverBadgeID, parms)
                .then(response => {
                    console.log(response);
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Bagde saved successfully'
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        this.$store.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        this.$store.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        checkExpireBadge: function(){
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('driver-badge/alerts', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.alerts = response.data;
                    this.dialog_alert = true;
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        deleteBadge: function (item) {
            this.$store.dispatch('setSnackbar', {
                color: 'success',
                text:
                    'Deleting badge with ID of ' +
                    item.DriverBadgeID +
                    ' from ' +
                    item.TerminalName
            });
            console.log(item);
            axios
                .delete('driver-badge/' + item.DriverBadgeID)
                .then(response => {
                    console.log(response);
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Badge deleted successfully'
                    });
                    this.chargeData();
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        this.$store.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        this.$store.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        loadBadges: function () {
            console.log(this.driver);
            this.terminals = [];
            this.$store.state.isLoading = true;
            axios
                .get('driver-badge/all/' + this.driver.id)
                .then(response => {
                    this.badgesLoad = response.data['Load'];
                    this.badgesUnLoad = response.data['UnLoad'];
                    console.log(this.badgesLoad);
                    this.badgesLoad.forEach(element => {
                        this.terminals.push(element.TerminalID);
                    });
                    console.log(this.terminals);
                    this.$store.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    this.$store.state.isLoading = false;
                });
        },
        loadCredentials: function () {
            axios
                .get('credential/' + this.driver.id)
                .then(response => {
                    this.credential = response.data;
                    console.log(this.credential);
                })
                .catch(function (error) {
                    console.log(error);
                    this.$store.state.isLoading = false;
                });
        },
        loadComboBoxType: function () {
            axios
                .get('credential-types')
                .then(response => {
                    this.credentials = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                    this.$store.state.isLoading = false;
                });
        },
        editCredential: function (itm) {
            var parms = {};
            if (typeof itm.credential_type.CredType === 'string') {
                parms = {
                    CredNumber: itm.CredNumber,
                    CredTypeID: itm.CredTypeID,
                    CredExpiry: itm.CredExpiry
                };
            } else {
                parms = {
                    CredNumber: itm.CredNumber,
                    CredTypeID: itm.credential_type.CredType.CredTypeID,
                    CredExpiry: itm.CredExpiry
                };
            }
            console.log(parms);
            axios
                .put('credential/' + itm.CredentialId, parms)
                .then(response => {
                    console.log(response);
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Bagde saved successfully'
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        this.$store.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        this.$store.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        deleteCredential: function (item) {
            this.$store.dispatch('setSnackbar', {
                color: 'success',
                text: 'Deleting credential with ID of ' + item.CredentialId
            });
            console.log(item);
            axios
                .delete('credential/' + item.CredentialId)
                .then(response => {
                    console.log(response);
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Credential deleted successfully'
                    });
                    this.chargeData();
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        this.$store.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        this.$store.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        chargeData: async function () {
            this.badge = [];
            this.credential = [];
            await this.loadCredentials();
            await this.loadBadges();
            await this.loadComboBoxType();
        },
        createReport: function (days = 30, type = 'badge') {
            this.$store.state.isLoading = true;
            this.report = [];
            if (type == 'badge') {
                this.type = 'badge';
                this.loadBadgeReport(days);
            } else if (type == 'credential') {
                this.type = 'credential';
                this.loadCredentialReport(days);
            }
        },
        getDaysUntilDate(date) {
            var today = new Date();
            var date2 = new Date(date);
            var diffTime = date2 - today;
            var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            return diffDays >= 0
                ? diffDays + ' Days left.'
                : -diffDays + ' Days ago.';
        },
        loadBadgeReport: function (days) {
            axios
                .get('driver-badge/report/' + days)
                .then(response => {
                    this.reportHeaders = this.badgeReportHeaders;
                    this.report = response.data.badges;
                    this.count = response.data.count;
                    console.log(this.report);
                    this.$store.state.report.dialog = true;
                    this.$store.state.isLoading = false;
                    console.log(this.$store.state.report.dialog);
                    if (days == -1) {
                        this.downloadDriverBadgeReport(this.report);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        loadCredentialReport: function (days) {
            axios
                .get('credential/report/' + days)
                .then(response => {
                    this.reportHeaders = this.credentialReportHeaders;
                    this.report = response.data.credentials;
                    this.count = response.data.count;
                    console.log(this.report);
                    this.$store.state.report.dialog = true;
                    this.$store.state.isLoading = false;
                    console.log(this.$store.state.report.dialog);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getExpirationColor: function (days, type = 'class') {
            if (type == 'color') {
                if (days <= 30) {
                    return 'red';
                } else if (days <= 60) {
                    return 'orange';
                } else {
                    return 'green';
                }
            } else if (type == 'class') {
                if (days <= 30) {
                    return 'red--text';
                } else if (days <= 60) {
                    return 'orange--text';
                } else {
                    return 'green--text';
                }
            }
        },
        getExpirationDate: function (days) {
            var today = new Date();
            var date = new Date(today);
            date.setDate(date.getDate() + days);
            return date.toLocaleDateString();
        },
        async cleanBadgesCredential() {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to clear all the badges assigned to this driver',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.CleanBadge(this.nav);

            }
        },
    }
};
</script>

<!--<style>
.divs {
  margin-top: 0px;
  padding-top: 0px;
}

.chps {
  width: 10px;
}
</style>
-->
